export default "__VITE_ASSET__O0vitX01__";